import React, { Component } from 'react';
import PropType from 'prop-types';
import { InputNumber, Icon } from 'antd';

class EditableCell extends Component {
  static propTypes = {
    value: PropType.number,
    onChange: PropType.func,
  }

  static defaultProps = {
    value: 0,
    onChange: undefined,
  }

  state = {
    value: this.props.value,
    editable: false,
  }
  handleChange = (value) => {
    if (!value) {
      this.setState({ value: 0 });
    } else {
      this.setState({ value });
    }
  }
  check = () => {
    this.setState({ editable: false });
    if (this.props.onChange) {
      this.props.onChange(this.state.value);
    }
  }
  edit = () => {
    this.setState({ editable: true });
  }
  render() {
    const { value, editable } = this.state;
    return (
      <div className="editable-cell">
        {
          editable ?
            <div className="editable-cell-input-wrapper">
              <InputNumber
                value={value}
                onChange={this.handleChange}
                onPressEnter={this.check}
              />

              <Icon
                type="check"
                className="editable-cell-icon-check"
                onClick={this.check}
              />
            </div>
            :
            <div className="editable-cell-text-wrapper">
              {value || ' '}
              <Icon
                type="edit"
                className="editable-cell-icon"
                onClick={this.edit}
              />
            </div>
        }
      </div>
    );
  }
}

export default EditableCell;



// WEBPACK FOOTER //
// ./src/components/EditableCell/index.js